import * as React from "react";
import {AbstractInputElement, FormElement} from "./FormInput";
import * as _ from "lodash";


interface SelectInputProps extends FormElement<any, HTMLSelectElement> {
    values?: any[];
    displayValue?: (value: any) => string;
    optionModelValue?: (value: any) => any;
    onChange?: () => void;
    sort?: boolean;
    disabled?: boolean;
}

export class SelectInput extends AbstractInputElement<any, SelectInputProps, {}> {


    constructor(props: SelectInputProps) {
        super(props);

        const doSort = props.sort == undefined ? true : props.sort;

        if (doSort && props.values) {
            props.values.sort((a, b) => {
                const aVal = this.getDisplayValue(a).toLocaleLowerCase();
                const bVal = this.getDisplayValue(b).toLocaleLowerCase();
                return aVal.localeCompare(bVal);
            });
        }
    }

    getDefaultValue() {
        let value = this.props.modelValue;
        if (this.props.modelValue == null || this.props.modelValue == "" || typeof(this.props.modelValue) == "undefined") {
            if (this.props.values && this.props.values.length > 0) {
                console.log("Update model values = ", this.props.values, this.props.values[0]);
                value = this.getFirstValue();
                if (this.props.multiple == true) {
                    value = [value];
                }
            }
        } else if (this.props.defaultValue == null && this.props.required == true) {
            console.warn("No default value set for required select input " + this.props.model);
        }

        return value;
    }

    private getFirstValue() {
        if (this.props.optionModelValue) {
            return this.props.optionModelValue(this.props.values[0]);
        } else {
            return this.props.values[0];
        }
    }

    shouldComponentUpdate(nextProps: SelectInputProps, nextState) {

        let update = super.shouldComponentUpdate(nextProps, nextState);
        if (update) {
            return true;
        }
        if (!_.isEqual(nextProps, this.props)) {
            return true;
        } else {
            return false;
        }
    }

    onChange(event: React.FormEvent): void {
        if (this.props.onChange) {
            this.props.onChange();
        }

        if (this.props.multiple == true) {
            var options = (event.target as any).options;
            var values = [];
            for (var i = 0, l = options.length; i < l; i++) {
                if (options[i].selected) {
                    values.push(options[i].value);
                }
            }
            this.updateModelValue(values, false);
        } else if ("" + parseInt(this.getModelValue()) == this.getModelValue()) {
            var value: number = parseInt((event.target as any).value);
            this.updateModelValue(value, false);
        } else {
            this.updateModelValue((event.target as any).value, false);
        }

    }

    getDisplayValue(val: any): string {
        if (this.props.displayValue) {
            return this.props.displayValue(val);
        } else {
            return val;
        }
    }

    getOptionModelValue(val: any) {
        if (this.props.optionModelValue) {
            return this.props.optionModelValue(val);
        } else {
            return val;
        }
    }

    getOptions() {
        if (this.props.values != null && typeof this.props.values != "undefined") {
            return this.props.values.map(v => {
                var optionValue = this.getOptionModelValue(v);
                return <option key={optionValue} value={optionValue}>{this.getDisplayValue(v)}</option>
            });
        }
        return [];
    }

    render() {
        let rest = _.omit(this.props, ['model', 'displayValue', 'optionModelValue', 'values', 'validators', `fieldSet`, `modelValue`, `valid`, 'validationMap', 'defaultValue']);
        return <select {...rest} multiple={this.props.multiple} className={this.getClassNames()}
                       disabled={this.props.disabled}
                       value={this.props.modelValue}
                       onChange={this.onChange.bind(this)}>{this.props.children}{this.getOptions()}</select>
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/form/SelectInput.tsx